import { render, staticRenderFns } from "./display-pos-incidents-count.vue?vue&type=template&id=64a84769&scoped=true&"
import script from "./display-pos-incidents-count.ts?vue&type=script&lang=ts&"
export * from "./display-pos-incidents-count.ts?vue&type=script&lang=ts&"
import style0 from "./display-pos-incidents-count.scss?vue&type=style&index=0&id=64a84769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a84769",
  null
  
)

export default component.exports